module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("your nutrition"), _c('br'), _c('strong', [_vm._v("SOLUTION")]), _c('br'), _vm._v("to a"), _c('br'), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HEALTHY GUT")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("a meal-based plan to help prevent and treat constipation, diverticulitis, ulcers, and other common digestive problems")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("kimberly a. tessmer, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RDN, LD")])])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "102",
      "src": "images/pub.jpg",
      "width": "438"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24473954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 63
// module chunks = 0